document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-cellini-collection-select]');
  if (select?.value) window.location.assign(select.value);
});

document.addEventListener('submit', (event) => {
  const form = event.target.closest('[data-cellini-collection-search]');
  if (!form) return;
  const input = form.querySelector('input[name="q"]');
  const handle = form.dataset.collectionHandle;
  if (!input || !/^[a-z0-9-]+$/.test(handle || '')) return;
  const query = input.value.trim();
  if (!query) return;
  const words = query.match(/[\p{L}\p{N}]+/gu)?.slice(0, 12);
  if (!words?.length) {
    event.preventDefault();
    return;
  }
  input.value = `tag:"cat:${handle}" AND ${words.map((word) => `title:${word}`).join(' AND ')}`;
});

document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || form.matches('[data-cellini-collection-search]')) return;
  const action = new URL(form.action, window.location.href);
  if (!/(^|\/)search\/?$/.test(action.pathname)) return;
  const input = form.querySelector('input[name="q"]');
  if (!input) return;
  const query = input.value.trim();
  if (!query || /^(?:title:|tag:|type:)/i.test(query)) return;
  // Shopify's title: operator does not match translated Arabic product titles.
  if (document.documentElement.lang.toLowerCase().startsWith('ar')) return;
  // Reference numbers and SKUs should use Shopify's indexed product fields.
  if (/^[A-Za-z0-9][A-Za-z0-9-]{4,}$/.test(query) && /\d/.test(query)) return;
  const words = query.match(/[\p{L}\p{N}]+/gu)?.slice(0, 12);
  if (!words?.length) return;
  input.value = words.map((word) => `title:${word}`).join(' AND ');
});
